import * as yup from "yup"
import { isPossiblePhoneNumber } from "libphonenumber-js"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

export const useMerchantValidationSchema = () => {
    const { l10n } = useAppLocalization()

    return yup.object({
        name: yup.string().required(l10n.getString("create-or-edit-supplier-admin-merchant-field-is-required")),
        address: yup.object({
            street: yup.string().required(l10n.getString("create-or-edit-supplier-admin-merchant-field-is-required")),
            streetNumber: yup
                .string()
                .required(l10n.getString("create-or-edit-supplier-admin-merchant-field-is-required")),
            postalCode: yup
                .string()
                .required(l10n.getString("create-or-edit-supplier-admin-merchant-field-is-required")),
            city: yup.string().required(l10n.getString("create-or-edit-supplier-admin-merchant-field-is-required")),
        }),
        contactDetails: yup.object({
            phoneNumber: yup.string().test({
                name: "is-valid-phoneNumber",
                test: (value) => (value ? isPossiblePhoneNumber(value, "DK") : true),
                message: l10n.getString("office-manager-create-user-invalid-phone-number"),
            }),
            email: yup.string().email(l10n.getString("office-manager-create-user-invalid-email-address")),
        }),
    })
}
